import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'

import BkFlowNavigationDefault from './layouts/BkFlowNavigationDefault'
import BkFlowNavigationBasic from './layouts/BkFlowNavigationBasic'
import BkFlowNavigationCurrency from './layouts/BkFlowNavigationCurrency'
import BkFlowNavigationGridSteps from './layouts/BkFlowNavigationGridSteps'

import BkFlowNavigationBackButton from './elements/BkFlowNavigationBackButton'
import BkFlowNavigationDetails from './BkFlowNavigationDetails'
import BkFlowEditStay from '../../edit/BkFlowEditStay'

import setActiveStep from '../../../actions/activeStepActions'

import formatPrice from '../../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'

// GA events handler
import triggerCustomGaEvent from '../../../utilities/analytics/triggerCustomGaEvent'

import moment from 'moment/moment'
import _ from 'lodash'
import yn from 'yn'

class BkFlowNavigation extends Component {
	constructor(props) {
		super(props)
		this.state = {
			detailsExpanded: false
		}
	}

	componentDidMount() {
		if (yn(process.env.REACT_APP_COMPONENT_ENABLE_NAVIGATION_DETAILS)) {
			const navigationDetails = document.getElementById('bk-flow-navigation-details')

			if (yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION)) {
				navigationDetails.classList.add('sticky')
			}

			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_NAVIGATION_DETAILS) &&
				yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)
			) {
				navigationDetails.classList.add('inc-utility')
			}
		}

		if (
			process.env.REACT_APP_COMPONENT_NAVIGATION === 'currency' &&
			process.env.REACT_APP_COMPONENT_ROOM_CARD_COMPONENT === 'multi-stage'
		) {
			window.addEventListener('scroll', handleScroll)

			function handleScroll() {
				if (window.scrollY >= 1) {
					document.body.classList.add('scrolled')
				} else {
					document.body.classList.remove('scrolled')
				}
			}
		}
	}

	// Handle details accordion
	handleDetailsAccordion() {
		this.setState({
			detailsExpanded: !this.state.detailsExpanded
		})

		const navigationDetailsData = {
			expanded: !this.state.detailsExpanded
		}

		triggerCustomGaEvent('analytics-navigationDetailsView', navigationDetailsData)
	}

	renderBackButton(isMobileButton) {
		const {
			configData,
			urlData,
			activeStep,
			availabilityLoading,
			handleBack
		} = this.props
		const hotelLabels = configData.hotel.labels[0]

		let stepThreshold = 1,
				activeHotelCode = null,
				activePropertyLink = null

		// Get hotel code from url
		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			if ( !_.isEmpty(matchedProperty) && matchedProperty.marketingLink ) {
				activePropertyLink = matchedProperty.marketingLink
			} else if (configData.core.options.links.brandMarketingLink){
				activePropertyLink = configData.core.options.links.brandMarketingLink
			}
		}

		// Update threshold if preRes services component
		if (yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS)) {
			stepThreshold = 2
		}

		if ( activeStep === 0 ) {
			return (
				<BkFlowNavigationBackButton
					isMobileButton={ isMobileButton }
					isDisabled={ availabilityLoading  }
					toggleEvent={ activePropertyLink ? () => window.location = activePropertyLink : () => window.location = '/' }
					buttonContent={ hotelLabels.home }
				/>
			)
		} else if ( activeStep > 0 && activeStep <= stepThreshold ) {
			return (
				<BkFlowNavigationBackButton
					isMobileButton={ isMobileButton }
					isDisabled={ availabilityLoading  }
					toggleEvent={ () => handleBack(activeStep)  }
					buttonContent={ hotelLabels.back }
				/>
			)
		} else {
			return (
				<BkFlowNavigationBackButton
					isMobileButton={ isMobileButton }
					isDisabled={ availabilityLoading  }
					toggleEvent={ activePropertyLink ? () => window.location = activePropertyLink : () => window.location = '/' }
					buttonContent={ hotelLabels.home }
				/>
			)
		}
	}


	// Construct dynamic navigation
	renderNavigation = () => {
		const {
			activeCurrencyData,
			activeEnhancementData,
			activeRestaurantsData,
			activeRoom,
			activeStep,
			availabilityData,
			configData,
			exchangeRatesLoading,
			handleUpdateStep,
			multiRoomData,
			toggleEditModal,
			urlData,
		} = this.props
		const { detailsExpanded } = this.state

		const addTotals = (a, b) => a + b,
					hotelLabels = configData.hotel.labels[0]

		let	activeHotel = '--',
				activeHotelCode = null,
				activeHotelPhoneNumber = null,
				activePropertyLink = null,
				activeHotelLogo = null

		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			// Set phone # by config or API Provider fallback
			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.reservations
			) {
				activeHotelPhoneNumber = matchedProperty.contactNumbers.reservations
			} else if (
				!_.isEmpty(availabilityData.availability) &&
				_.get(availabilityData.availability, '[0][0].basicPropertyInfo.contactNumbers[0].phoneNumber')
			) {
				activeHotelPhoneNumber = availabilityData.availability[0][0].basicPropertyInfo.contactNumbers[0].phoneNumber
			}

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.marketingLink
			) {
				activePropertyLink = matchedProperty.marketingLink
			} else if (
				configData.core.options.links.brandMarketingLink
			){
				activePropertyLink = configData.core.options.links.brandMarketingLink
			}
		}

		// Setting activeHotel and phone number
		if (
			!_.isEmpty(availabilityData.availability) &&
			_.get(availabilityData.availability, '[0][0].basicPropertyInfo')
		) {
			if (_.get(availabilityData.availability, '[0][0].basicPropertyInfo.hotelName')) {
				activeHotel = availabilityData.availability[0][0].basicPropertyInfo.hotelName
			}

		  if (
		  	_.get(availabilityData, 'availability[0][0].basicPropertyInfo.viewExtensions.logo') &&
				!_.isEmpty(availabilityData.availability[0][0].basicPropertyInfo.viewExtensions.logo)
			) {
				 if (
						process.env.REACT_APP_COMPONENT_NAVIGATION_DEFAULT_LOGO === 'light' &&
						!_.isEmpty(availabilityData.availability[0][0].basicPropertyInfo.viewExtensions.logo.light)
				 ) {
					 activeHotelLogo = (
						 <img
							 src={ availabilityData.availability[0][0].basicPropertyInfo.viewExtensions.logo.light }
							 alt={ activeHotel && activeHotel }
						 />
					 )
				 } else if (
				 	  process.env.REACT_APP_COMPONENT_NAVIGATION_DEFAULT_LOGO === 'dark'&&
					 !_.isEmpty(availabilityData.availability[0][0].basicPropertyInfo.viewExtensions.logo.dark)
				 ) {
					 activeHotelLogo = (
						 <img
							 src={ availabilityData.availability[0][0].basicPropertyInfo.viewExtensions.logo.dark }
							 alt={ activeHotel && activeHotel }
						 />
					 )
				 }
			}
		}

		if (urlData) {

			// Init Nav Structures
			let renderArrival = '',
				renderDeparture = '',
				renderGuests = '',
				guestsTotalData = [],
				renderRoomAmount = '--',
				roomTotalData = [],
				enhancementTotalData = [],
				enhancementTotalsSum = 0,
				renderEnhancementsTotal = '--',
				grandTotalData = [],
				renderGrandTotal = '--',
				currencyCode = null,
				currencySymbol = null

			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.currencyCode
			) {
				currencyCode = activeCurrencyData.currencyCode

				if (activeCurrencyData.currencySymbol) {
					currencySymbol = activeCurrencyData.currencySymbol
				} else {
					currencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
				}
			} else if (
				activeRoom[0] &&
				_.get(activeRoom[0], '[1][0].rates[0].total.currencyCode')
			) {
				currencyCode = activeRoom[0][1][0].rates[0].total.currencyCode
				currencySymbol = getCurrencySymbol(currencyCode)
			}

			// Session data for guests / pets
			let flowGuestData = null

			if (localStorage.flowGuestData) {
				flowGuestData = JSON.parse(localStorage.flowGuestData)
			}

			// Build guest count
			if (!_.isEmpty(flowGuestData)) {
				for (const roomGroupKey in flowGuestData) {

					// Adults total
					if (flowGuestData[roomGroupKey].adults) {
						guestsTotalData.push(Number(flowGuestData[roomGroupKey].adults))
					}

					// Children total
					if (flowGuestData[roomGroupKey].children) {
						guestsTotalData.push(Number(flowGuestData[roomGroupKey].children))
					}
				}

				renderGuests = <p className="u-remove-margin u-font-medium">{guestsTotalData.reduce(addTotals)}</p>
			} else if (urlData.adults) {

				// Adults total by urlData
				if (urlData.adults) {
					guestsTotalData.push(Number(urlData.adults))
				}

				// Children total by urlData
				if (urlData.children) {
					guestsTotalData.push(Number(urlData.children))
				}

				renderGuests = <p className="u-remove-margin u-font-medium">{guestsTotalData.reduce(addTotals)}</p>
			} else {
				renderGuests = <p className="u-remove-margin u-font-medium">--</p>
			}

			// Build Arrival
			if (urlData.startDate) {
				renderArrival = <span>{moment(urlData.startDate).format('dddd, MMMM D, YYYY')}</span>
			} else {
				renderArrival = <span>--</span>
			}

			// Build Departure
			if (urlData.endDate) {
				renderDeparture = <span>{moment(urlData.endDate).format('dddd, MMMM D, YYYY')}</span>
			} else {
				renderDeparture = <span>--</span>
			}

			// Build Room Amount
			if (multiRoomData.isMultiRoom && multiRoomData.multiRoomTotal > 1) {
				renderRoomAmount = <span>{multiRoomData.multiRoomTotal} {hotelLabels.rooms}</span>
			} else {
				renderRoomAmount = <span>1 {hotelLabels.room}</span>
			}

			if (!_.isEmpty(activeRoom)) {

				// Loop active rooms and build structures
				for (const roomKey in activeRoom) {
					const addTotals = (a, b) => a + b

					//Build Grand Total
					if (activeRoom[roomKey][1][0].rates[0].total.amountAfterTax) {

						// Combine and add room totals
						roomTotalData.push(Number(activeRoom[roomKey][1][0].rates[0].total.amountAfterTax))

						// Build enhancement totals by total dollar value
						if (process.env.REACT_APP_COMPONENT_NAVIGATION_SERVICES_FORMAT === 'total') {
							if (!_.isEmpty(activeEnhancementData)) {
								// Loop for related enhancements by roomGroup and roomType
								for (const enhancementKeys in activeEnhancementData) {
									if (
										Number(activeEnhancementData[enhancementKeys].roomGroup) === Number(roomKey) &&
										activeEnhancementData[enhancementKeys].roomType === activeRoom[roomKey][0][0].roomTypeCode
									) {
										enhancementTotalData.push(activeEnhancementData[enhancementKeys].enhancementApiData.price[0].base.amountAfterTax)
									}
								}
							}

							// Combine enhancement totals
							enhancementTotalsSum = enhancementTotalData.reduce(addTotals, 0)
							renderEnhancementsTotal = currencySymbol + formatPrice(enhancementTotalsSum, 2)
						}
					}
				}

				// Combine all totals into a single value ELSE fallback to 0
				let roomTotalsSum

				if (!_.isEmpty(roomTotalData)) {
					roomTotalsSum = roomTotalData.reduce(addTotals)
				}

				// Create grand total data (add services to total based on ENV var)
				if (yn(process.env.REACT_APP_COMPONENT_INCLUDE_SERVICES_IN_TOTAL)) {
					grandTotalData.push(roomTotalsSum, enhancementTotalsSum)
				} else {
					grandTotalData.push(roomTotalsSum)
				}

				// Combine totals (rate + tax) if necessary into a grand total
				const grandTotalSum = grandTotalData.reduce(addTotals, 0)

				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
					activeCurrencyData &&
					activeCurrencyData.exchangeRate
				) {
					renderGrandTotal = currencySymbol + formatPrice(grandTotalSum * activeCurrencyData.exchangeRate, 2)
				} else {
					// Format grand total
					renderGrandTotal = currencySymbol + formatPrice(grandTotalSum, 2)
				}
			}

			// Build enhancement totals by line item count
			if (process.env.REACT_APP_COMPONENT_NAVIGATION_SERVICES_FORMAT === 'line-items') {
				if (!_.isEmpty(activeEnhancementData)) {
					enhancementTotalData.push(Object.keys(activeEnhancementData).length)
				}

				if (!_.isEmpty(activeRestaurantsData)) {
					enhancementTotalData.push(Object.keys(activeRestaurantsData).length)
				}

				enhancementTotalsSum = enhancementTotalData.reduce(addTotals, 0)

				if (enhancementTotalsSum === 0) {
					renderEnhancementsTotal = '--'
				} else if (enhancementTotalsSum === 1) {
					renderEnhancementsTotal = enhancementTotalsSum + ' Item'
				} else if (enhancementTotalsSum > 1) {
					renderEnhancementsTotal = enhancementTotalsSum + ' Items'
				} else {
					renderEnhancementsTotal = '--'
				}
			}

			if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'default') {
				return (
					<BkFlowNavigationDefault
						activeCurrencyData={activeCurrencyData}
						configData={configData}
						backButton={(isMobile) => this.renderBackButton(isMobile)}
						hotel={activeHotel}
						hotelPhone={activeHotelPhoneNumber}
						hotelLogo={activeHotelLogo}
						hotelLink={activePropertyLink}
						arrival={renderArrival}
						departure={renderDeparture}
						guests={renderGuests}
						rooms={renderRoomAmount}
						detailsExpanded={detailsExpanded}
						detailsEvent={() => this.handleDetailsAccordion()}
						exchangeRatesLoading={exchangeRatesLoading}
						openEditModal={() => toggleEditModal()}
					/>
				)
			} else if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'basic') {
				return (
					<BkFlowNavigationBasic
						activeCurrencyData={activeCurrencyData}
						exchangeRatesLoading={exchangeRatesLoading}
						hotel={activeHotel}
						hotelLogo={activeHotelLogo}
						hotelLink={activePropertyLink}
						openEditModal={() => toggleEditModal()}
					/>
				)
			} else if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'currency') {
			 	return (
					<BkFlowNavigationCurrency
						activeCurrencyData={activeCurrencyData}
						configData={configData}
						backButton={(isMobile) => this.renderBackButton(isMobile)}
						hotel={activeHotel}
						hotelPhone={activeHotelPhoneNumber}
						hotelLogo={activeHotelLogo}
						hotelLink={activePropertyLink}
						arrival={renderArrival}
						departure={renderDeparture}
						guests={renderGuests}
						detailsExpanded={detailsExpanded}
						detailsEvent={() => this.handleDetailsAccordion()}
						exchangeRatesLoading={exchangeRatesLoading}
						openEditModal={() => toggleEditModal()}
					/>
				)
			} else {
				return (
					<BkFlowNavigationGridSteps
						configData={configData}
						backButton={(isMobile) => this.renderBackButton(isMobile)}
						activeStep={activeStep}
						activeCurrencyData={activeCurrencyData}
						hotel={activeHotel}
						hotelPhone={activeHotelPhoneNumber}
						hotelLogo={activeHotelLogo}
						hotelLink={activePropertyLink}
						arrival={renderArrival}
						departure={renderDeparture}
						guests={renderGuests}
						rooms={renderRoomAmount}
						enhancementsTotal={renderEnhancementsTotal}
						exchangeRatesLoading={exchangeRatesLoading}
						grandTotal={renderGrandTotal}
						detailsExpanded={detailsExpanded}
						updateStep={ (activeStep) => handleUpdateStep(activeStep) }
						detailsEvent={() => this.handleDetailsAccordion()}
						openEditModal={() => toggleEditModal()}
					/>
				)
			}
		}
	}

	renderEditStay() {
		const {
			editModalVisible,
			toggleEditModal,
		} = this.props

		let baseModalClassNames = 'u-modal u-modal--xxs'

		if (process.env.REACT_APP_COMPONENT_EDIT_STAY_LAYOUT === 'xsmall') {
			baseModalClassNames = 'u-modal u-modal--xs'
		} else if (process.env.REACT_APP_COMPONENT_EDIT_STAY_LAYOUT === 'small') {
			baseModalClassNames = 'u-modal u-modal--sm'
		} else if (process.env.REACT_APP_COMPONENT_EDIT_STAY_LAYOUT === 'medium') {
			baseModalClassNames = 'u-modal u-modal--md'
		} else if (process.env.REACT_APP_COMPONENT_EDIT_STAY_LAYOUT === 'large') {
			baseModalClassNames = 'u-modal u-modal--lg'
		}

		return (
			<Modal
				className={{
					base: baseModalClassNames,
					afterOpen: 'u-modal--visible',
					beforeClose: 'u-modal--close',
					ariaHideApp: false
				}}
				overlayClassName={{
					base: 'u-fade',
					afterOpen: 'u-fade--visible',
					beforeClose: 'u-fade--visible'
				}}
				isOpen={ editModalVisible }
				onRequestClose={ toggleEditModal }
				contentLabel="Cancel Reservation Modal"
				shouldCloseOnOverlayClick={ true }
				shouldFocusAfterRender={ true }
				ariaHideApp={ false }
			>
				<BkFlowEditStay closeEditModal={ toggleEditModal }/>
			</Modal>
		)
	}

	renderNavigationDetails() {
		const { detailsExpanded } = this.state

		return (
			<div
				id="bk-flow-navigation-details"
				className="bk-flow-navigation-details"
			>
				<BkFlowNavigationDetails detailsExpanded={ detailsExpanded } />
			</div>
		)
	}

	render() {
		const { configData } = this.props

		return (
			<Fragment>
				{ this.renderNavigation() }
				{ configData && configData.hotel && this.renderEditStay() }
				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_NAVIGATION_DETAILS) && this.renderNavigationDetails() }
			</Fragment>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeCurrencyData: state.activeCurrencyData,
		activeEnhancementData: state.activeEnhancementData,
		activeRestaurantsData: state.activeRestaurantsData,
		activeRoom: state.activeRoomData,
		activeStep: state.activeStepData.activeStep,
		availabilityData: state.availabilityData,
		availabilityLoading: state.availabilityData.loading,
		configData: state.configData.configuration,
		exchangeRatesLoading: state.exchangeRatesData.loading,
		multiRoomData: state.multiRoomData,
		urlData: state.availabilityData.urlData,
	}
}

const mapDispatchToProps = dispatch => ({
	handleBack(activeStep) {
		return (
			dispatch(setActiveStep(activeStep - 1))
		)
	},
	handleUpdateStep(activeStep) {
		return (
			dispatch(setActiveStep(activeStep))
		)
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowNavigation)


// WEBPACK FOOTER //
// ./src/components/structure/navigation/BkFlowNavigation.js